import { useRef, useState } from "react";
import {
  Box,
  Button,
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

import Hero from "../components/Hero";
import Details from "../components/Details";
import About from "../components/About";
import FAQ from "../components/Faq";

export default function Home() {
  const theme = useTheme();

  const detailsRef = useRef(null);
  const aboutRef = useRef(null);
  const whatToKnowRef = useRef(null);

  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  const getOffset = () => {
    if (isXs) return 80;
    if (isSmUp) return 75;
    return 80;
  };

  const scrollTo = (ref) => {
    if (ref?.current) {
      const elementPosition =
        ref.current.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - getOffset();

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const navItemStyle = {
    fontFamily: "Futura, sans-serif",
    fontSize: "20px",
    lineHeight: "24px",
    fontWeight: 400,
    color: theme.palette.text.primary,
    textTransform: "none",
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Box>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: theme.palette.custom.white,
          color: theme.palette.custom.black,
        }}
      >
        <Toolbar sx={{ position: "relative", minHeight: 80 }}>
          <Box
            component="img"
            src="/logo.png"
            alt="logo"
            sx={{
              maxHeight: 75,
              objectFit: "contain",
              position: { xs: "absolute", sm: "static" },
              left: { xs: "50%", sm: "auto" },
              transform: { xs: "translateX(-50%)", sm: "none" },
            }}
          />
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              gap: 3,
              marginLeft: "auto",
            }}
          >
            <Button onClick={() => scrollTo(detailsRef)} sx={navItemStyle}>
              details
            </Button>
            <Button onClick={() => scrollTo(aboutRef)} sx={navItemStyle}>
              about us
            </Button>
            <Button onClick={() => scrollTo(whatToKnowRef)} sx={navItemStyle}>
              what to know
            </Button>
          </Box>
          <Box
            sx={{ display: { xs: "block", md: "none" }, marginLeft: "auto" }}
          >
            <IconButton onClick={handleClick}>
              <MenuIcon sx={{ color: theme.palette.text.primary }} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={() => {
                  scrollTo(detailsRef);
                  handleClose();
                }}
                sx={navItemStyle}
              >
                details
              </MenuItem>
              <MenuItem
                onClick={() => {
                  scrollTo(aboutRef);
                  handleClose();
                }}
                sx={navItemStyle}
              >
                about us
              </MenuItem>
              <MenuItem
                onClick={() => {
                  scrollTo(whatToKnowRef);
                  handleClose();
                }}
                sx={navItemStyle}
              >
                what to know
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Hero />
      <Box ref={detailsRef} sx={{ width: "100%" }}>
        <Details />
      </Box>
      <Box ref={aboutRef} sx={{ width: "100%" }}>
        <About />
      </Box>
      <Box ref={whatToKnowRef} sx={{ width: "100%" }}>
        <FAQ />
      </Box>
    </Box>
  );
}
